import * as React from 'react';
import { GeneralInfo } from './MatterGeneralInfo';
import glamorous, { ThemeProvider } from 'glamorous';
import { mainTheme } from '../../Theme';
import { MatterOptions } from '../MatterDetails';

interface MatterGeneralInfoCardProps {
    title?: string;
    id: string;
    options: MatterOptions;
}

// tslint:disable-next-line:no-any
const DataGeneralInfoTable = glamorous.div<{theme?: any}>((props) => ({

    [`& .${`item`}`]: {
        display: 'inline-block !important',
        width: '100%',
        ':nth-of-type(even)': {
            borderRadius: '4px',
            backgroundColor: props.theme.NeutralColors.LightGrey1,
        },
        [`& .${`rvlabel`}`]: {
            fontSize: props.theme.FontSize.PX.size1 + ' !important',
            lineHeight: props.theme.LineHeight.Large,
        },
        [`& .${`value`}`]: {
            color: props.theme.BrandColors.TextPrimary,
            opacity: props.theme.Opacity.cat3,
        },
        [`& .${`ValueData`}`]: {
            color: props.theme.BrandColors.TextPrimary,
            opacity: props.theme.Opacity.cat3,
            [`& .${`rvlabel`}`]: {
                // color: props.theme.BrandColors.TextPrimary,
                // opacity: props.theme.Opacity.cat3,
                // paddingLeft: '1rem',
            }            
    },
        [`& .${`LabelData`}`]: {
            [`& .${`rvlabel`}`]: {
                paddingLeft: '1rem',
            }
        }, 
        [`& .${`label`}`]: {
            [`& .${`rvlabel`}`]: {
                paddingLeft: '1rem',
            }
        },        
        [`& .${`value span span`}`]: {
            paddingLeft: '1rem',
            lineHeight: props.theme.LineHeight.Large,
        }  
    } 

}));

export class RvMatterGeneralInfoCard extends React.Component<MatterGeneralInfoCardProps, {}>  {
    render() {
        return (
            <ThemeProvider theme={mainTheme}>
                <DataGeneralInfoTable>
                    <GeneralInfo 
                        id={this.props.id} 
                        options={this.props.options}
                    />
                </DataGeneralInfoTable>
            </ThemeProvider>
        );
    }
}
